<template>
  <div class="page-content-wrapper" v-check-permission="'list-registration-to-examination-tables'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Inscribir alumno a mesa de exámen</h4>

              <template v-if="item">

                <div class="form-group  mb-3" v-bind:class="{ 'has-danger': $v.item.user.$error }">
                  <label>Alumno</label>
                  <div class="col-md-10" style="padding-left: 0;">
                    <v-select id="user" :options="students" :value="item.user" v-model="item.user">
                      <span slot="no-options">No se han encontrado resultados.</span>
                    </v-select>
                  </div>
                  <small>Solo se listan los alumnos inscriptos al ciclo lectivo {{ currentYear }}. Si el alumno que estas buscando no aparece en esta lista, primero debes verificar si el mismo esta inscripto en el ciclo lectivo actual desde el modulo de Inscripción a carreras .</small>
                  <div class="form-control-feedback" v-if="!$v.item.user.required && $v.item.user.$error">El alumno es requerido.</div>
                </div>

                <div class="form-group mb-3" v-bind:class="{ 'has-danger': $v.item.examinationTable.$error }">
                  <label>Mesa de exámen</label>
                  <div class="col-md-8" style="padding-left: 0;">
                    <v-select id="examinationTable" :options="examinationTables" :value="item.examinationTable" v-model="item.examinationTable">
                      <span slot="no-options">No se han encontrado resultados.</span>
                    </v-select>
                    <div class="form-control-feedback" v-if="!$v.item.examinationTable.required && $v.item.examinationTable.$error">Seleccionar la mesa de exámen.</div>
                  </div>
                </div>

                <div class="mt-3">Seleccionar las materias:</div>

                <div class="row  mt-4" v-if="studyPlan && studyPlan.levels">

                  <h6 class="col-md-12">Plan de estudios: Res. {{ (studyPlan.resolution) }} ({{ (studyPlan.fileNumber) }})</h6>

                  <div class="col-md-4" v-for="level in studyPlan.levels">

                    <h5 class="mt-0 header-title">{{ level.value}} - {{ level.name }}</h5>

                    <div v-if="level && level.subjects" class="form-group  m-b-0">
                      <div v-for="subject in level.subjects">
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" v-bind:value="subject._id" v-model="item.subjects">
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description">{{ subject.curricularSpace }} <small>({{ getSubjectDuration(subject.duration) }})</small></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-2 d-inline-flex" v-else-if="!studyPlanError">
                  <span class="alert alert-danger">Para que las materias se listen primero debes seleccionar el alumno.</span>
                </div>
                <div class="mt-2 d-inline-flex" v-else>
                  <span class="alert alert-danger"><strong>
                    El alumno seleccionado no tiene asignado un plan de estudios en el ciclo lectivo actual.<br>
                    Por favor primero debe asignarle un plan de estudios desde el modulo de inscripción a las carreras.
                  </strong></span>
                </div>

                <div class="form-group"  v-bind:class="{ 'has-danger': $v.item.subjects.$error }">
                  <div class="form-control-feedback" v-if="!$v.item.subjects.required && $v.item.subjects.$error">Debes seleccionar al menos una materia para poder inscribir al alumno.</div>
                </div>

                <div class="card-block pull-right pr-0">
                  <router-link to="/list-of-registration-to-examination-tables" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, minValue } from 'vuelidate/lib/validators'
  import sizes from '../data/sizes'
  import vSelect from 'vue-select'
  import subjectDuration from '../data/subjectDuration'
  import { editRegistrationToExaminationTables } from '../api'

  export default {
    name: 'edit-inscription-into-registration-to-examination-tables',


    components: {
      vSelect
    },


    created () {
      this.getAllExaminationTables();
    },




    data () {
      return {
        students : [],
        examinationTables: [],
        item: {
          user: null,
          examinationTable: null,
          subjects: [],
          career: null,
        },
        studyPlan: null,
        studyPlanError: false,
        currentItem: null,
        subjectDuration: subjectDuration,
      }
    },


    watch:{
      'item.user': function (newUser, oldUser) {
        this.getCurrentStudent(newUser.value);

        if(this.currentItem && this.currentItem.current_career && this.currentItem.registration_to_career) {
          var currentStudyPlanId = this.currentItem.registration_to_career.studyPlan;
          var currentCareer = this.currentItem.current_career;
          if(currentCareer) {
            var studyPlans = currentCareer.studyPlans.filter(item => (item._id === currentStudyPlanId));
            if (studyPlans && studyPlans.length > 0) {
              this.studyPlan = studyPlans[0];
              this.studyPlanError = false;
            } else {
              this.studyPlan = null;
              this.studyPlanError = true;
            }

            this.item.subjects = [];
            if (currentCareer._id) {
              this.item.career = currentCareer._id;
            }
          }
        }
      }
    },




    computed: {
      studentsList: function () {
        return this.$store.getters.getListOfStudentsOfCurrentAcademicYear
      },

      listOfExaminationTables: function () {
        return this.$store.getters.getAllExaminationTables
      },

      currentYear: function() {
        var currentDate = new Date();

        return currentDate.getFullYear();
      }
    },




    validations: {
      item: {
        user: {
          required
        },
        examinationTable: {
          required
        },
        subjects: {
          required
        }
      }
    },




    methods: {

      getAllExaminationTables () {
        var self = this;
        self.$loader.loading();
        self.$store.dispatch('getAllExaminationTables')
          .then((response) => {
            if(response.success) {
              response.data.docs.forEach(function (item) {
                self.examinationTables.push({
                  label: item.name + ( item.called ? ' (' + item.called + ')' : '' ),
                  value: item._id
                })
              });

              self.getListOfStudentsOfCurrentAcademicYear();
            } else {
              this.$message.error({text: response.message});
              self.$loader.close();
            }
          })
          .catch((response) => {
            self.$loader.close();
            self.$message.error({text: response.message});
          })
      },




      getListOfStudentsOfCurrentAcademicYear () {
        var self = this;
        this.$loader.loading();
        self.$store.dispatch('getListOfStudentsOfCurrentAcademicYear')
          .then((response) => {

            if(response.success) {
              response.data.forEach(function (item) {
                self.students.push({
                  label: item.personalData.dni + ' - ' + item.personalData.lastName + ' ' + item.personalData.firstName + ' - (' + item.registration_to_career.level + 'º en ' + item.current_career.name + ')',
                  value: item.user
                })
              });

              this.$loader.close();
            } else {
              this.$loader.close();
            }
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },


      getCurrentStudent: function (userId) {
        var self = this;
        var students = self.studentsList.filter(item => (item.user === userId));
        if(students && students.length > 0) {
          self.currentItem = students[0];
        }
      },



      getSubjectDuration: function (key) {
        var subjectDuration = this.subjectDuration.filter(function (item) {
          return key === item.value;
        });
        if(subjectDuration && subjectDuration.length > 0) {
          return subjectDuration[0].text;
        }
        return '--';
      },




      submit: function () {
        const self = this
        this.$v.item.$touch()

        if(!this.$v.item.$error) {

          $('.save-btn').attr('disabled', true);

          editRegistrationToExaminationTables(this.item)
            .then((response) => {
              console.log(response);
              if(response.body.success) {
                self.$message.success();

                setTimeout(function () {
                  self.$router.push('/list-of-registration-to-examination-tables')
                }, 500);
              } else {
                self.$message.error({text: response.message});
              }

              $('.save-btn').attr('disabled', false);
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false);
            })

        }
      }

    }
  }
</script>

<style scoped>

  .v-select .dropdown-toggle::after {
    content: normal;
  }

</style>



// WEBPACK FOOTER //
// src/screens/EditIncriptionIntoRegistrationToExaminationTables.vue